import { css } from '@emotion/core'
import { smallOnly, mediumUp, largeUp } from 'Utils'
import theme from 'Theme'

const { typography, mixins, spacing, colors } = theme

export const plain = () => {
  const { defaultButton, sectionHeading } = mixins

  return css`
    background-color: ${colors.white};
    padding: ${spacing.vertical.large} 0;

    @media ${mediumUp} {
      padding: ${spacing.vertical.large} 0;
    }

    .article-list__grid {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      flex-wrap: wrap;

      @media ${mediumUp} {
        flex-direction: row;
      }

      > * {
        position: relative;

        @media ${smallOnly} {
          margin-bottom: 16px;
          &:last-of-type {
            margin-bottom: 0;
          }
        }

        @media ${mediumUp} {
          width: calc(33.33% - 16px);
        }

        @media ${largeUp} {
          width: calc(25% - 16px);
        }
      }
    }

    .article-list__title {
      display: table;
      ${sectionHeading(theme)}
    }

    .article-list__sub-title {
      font-weight: normal;
      text-align: center;
      font-family: ${typography.body.fontFamily};
      display: table;
      line-height: 1.4em;
      font-size: ${typography.baseFontSize};
      max-width: 350px;
      margin: 0 auto ${spacing.vertical.medium} auto;
      @media ${mediumUp} {
        max-width: 400px;
      }
    }

    .article-list__cta {
      display: table;
      .cta {
        ${defaultButton(theme)}
      }
    }

    .article-list__title {
      margin: 0 auto ${spacing.vertical.xsmall} auto;
    }

    .article-list__grid {
      margin: 0 auto ${spacing.vertical.large} auto;
    }

    .article-list__cta {
      margin: 0 auto;
      @media ${mediumUp} {
        margin-top: ${spacing.vertical.medium};
      }
    }
  `
}

export default plain
